/** Panel claro para modales admin portaled al body (dashboard / gym). */
export const ADMIN_FORM_MODAL_PANEL = 'form-modal d28d-admin-modal ui-light-panel surface-readable bg-white border border-slate-200 w-full';
